import { SamplingSuppliesCategory } from '../../model/sampling-supply-category.model';
import * as Actions from './sampling-supplies.actions';
import { CatalogueItem } from '../../model/catalogue-category/catalogue-item.model';
import { getCollectionIds } from '../../order-checkout/shared/cart';

export interface CatalogueItemEntities { [key: number]: CatalogueItem }
export interface CategoryToCatalogueItemsMap { [key: number]: number[] }

export interface State {
    categories: SamplingSuppliesCategory[];
    catalogueItems: CatalogueItem[];
    catalogueItemEntities: CatalogueItemEntities;
    categoryToCatalogueItemsMap: CategoryToCatalogueItemsMap;
    loadedCategoryIds: number[];
    loading: boolean;
    loadingCategoryIds: number[];
}

const initialState = {
    categories: [],
    catalogueItems: [],
    catalogueItemEntities: {},
    categoryToCatalogueItemsMap: {},
    loadedCategoryIds: [],
    loading: false,
    loadingCategoryIds: []
};

export function SamplingSuppliesReducer(state = initialState, action: Actions.SamplingSuppliesActions) {

    switch (action.type) {
    case Actions.LOAD_CATEGORIES:
        return {
            ...state,
            loading: true
        };
    case Actions.LOAD_CATEGORIES_SUCCESS:
        return {
            ...state,
            loading: false,
            categories: action.categories
        };
    case Actions.LOAD_CATEGORIES_FAIL:
        return { ...state, loading: false };
    case Actions.LOAD_CATALOGUE_ITEMS:
        let ids = [...state.loadingCategoryIds];
        if (ids.indexOf(action.categoryId) === -1) {
            ids = [...ids, action.categoryId];
        }

        return {
            ...state,
            loadingCategoryIds: [...ids],
        };
    case Actions.ADD_CATALOGUE_ITEMS:

        let stateItems = state.catalogueItems;
        const items = action.catalogueItems;
        const itemsIds = getCollectionIds('id', items);
        // filter state items to be replaced with new ones
        stateItems = stateItems.filter(t => itemsIds.indexOf(t.id) === -1);

        const entities = toMap(items);
        const stateEntities = state.catalogueItemEntities;

        return {
            ...state,
            catalogueItems: [...stateItems, ...items],
            catalogueItemEntities: { ...stateEntities, ...entities }
        };

    case Actions.ADD_LOADED_CATEGORY_ID:
        if (state.loadedCategoryIds.indexOf(action.categoryId) === -1) {
            return {
                ...state,
                loadedCategoryIds: [...state.loadedCategoryIds, action.categoryId]
            };
        }
        return state;
    case Actions.LOAD_CATALOGUE_ITEMS_SUCCESS:
        return {
            ...state,
            categoryToCatalogueItemsMap: { ...state.categoryToCatalogueItemsMap, [action.categoryId]: action.itemIds },
            loadingCategoryIds: state.loadingCategoryIds.filter(id => id !== action.categoryId)
        };
    case Actions.LOAD_CATALOGUE_ITEMS_FAIL:
        return {
            ...state,
            loadingCategoryIds: state.loadingCategoryIds.filter(id => id !== action.categoryId)
        };
    default:
        return state;
    }
}

export const getCatalogueItems = (state: State) => state.catalogueItems;
export const getLoadedCategoryIds = (state: State) => state.loadedCategoryIds;
export const getSamplingSuppliesLoading = (state: State) => state.loading;
export const getLoadingCategoryIds = (state: State) => state.loadingCategoryIds;
export const getCategories = (state: State) => state.categories;
export const getCatalogueItemEntities = (state: State) => state.catalogueItemEntities;
export const getCategoryToCatalogueItemsMap = (state: State) => state.categoryToCatalogueItemsMap;

const toMap = (items: CatalogueItem[]) => items.reduce((r, c) => ({ ...r, [c.id]: c }), {});


